module.exports = __webpack_public_path__ + "ui-static/img/empty_light.326a97fa.svg";